export default __webpack_public_path__ + "static/media/logout.c8c4148a.png";